import request from '@/utils/request'

let CityagencyApi = {
  /*列表*/
  Cityagencylist(data, errorback) {
    return request._post('/shop/city.index/index', data, errorback);
    },


  /*获取*/
  getCityagency(data, errorback) {
    return request._get('/shop/city.index/add', data, errorback);
  },
  /*添加*/
  addCityagency(data, errorback) {
    return request._post('/shop/city.index/add', data, errorback);
  },
  
  /*编辑*/
  geteditCityagency(data, errorback) {
    return request._get('/shop/city.index/edit', data, errorback);
    },
   /*编辑*/
  editCityagency(data, errorback) {
    return request._post('/shop/city.index/edit', data, errorback);
  },
  /*删除*/
  deleteCityagency(data, errorback) {
    return request._post('/shop/city.index/delete', data, errorback);
  },
  

}
export default CityagencyApi;



// WEBPACK FOOTER //
// ./src/api/cityagency.js